// src/admin/components/AnalyticsBarChart.jsx

import {

    ResponsiveContainer,

    BarChart,

    Bar,

    XAxis,

    YAxis,

    CartesianGrid,

    Tooltip,

    Legend,

} from "recharts";

import { useTheme } from "../../context/ThemeContext";

export default function AnalyticsBarChart({

    title,

    description,

    data = [],

    xKey,

    bars = [],

}) {

    const { isDark } = useTheme();

    return (

        <section
            className={`
                rounded-3xl
                border
                p-8
                ${
                    isDark
                        ? "bg-white/5 border-white/10"
                        : "bg-white border-gray-200"
                }
            `}
        >

            <div className="mb-8">

                <h2 className="text-xl font-semibold">

                    {title}

                </h2>

                {description && (

                    <p className="mt-2 text-sm opacity-70">

                        {description}

                    </p>

                )}

            </div>

            <ResponsiveContainer
                width="100%"
                height={350}
            >

                <BarChart data={data}>

                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis dataKey={xKey} />

                    <YAxis />

                    <Tooltip />

                    <Legend />

                    {bars.map(bar => (

                        <Bar
                            key={bar.dataKey}
                            dataKey={bar.dataKey}
                            fill={bar.color}
                            name={bar.name}
                            radius={[8, 8, 0, 0]}
                        />

                    ))}

                </BarChart>

            </ResponsiveContainer>

        </section>

    );

}